export const PRE_ANESTHETIC_CONCENTRATIONS = {
  Acepromazine: 10,
  Butorphanol: 10,
  Midazolam: 5,
  Dexmedetomidine: 0.5,
  Hydromorphone: 2,
  Morphine: 10,
  Alfaxalone: 10
};

export const INDUCTION_CONCENTRATIONS = {
  Propofol: 10,
  Alfaxalone: 10,
  Midazolam: 5,
  Buprenorphine: 0.5
};

export const ADDITIONAL_CONCENTRATIONS = {
  Rimadyl: 50,
  Convenia: 80,
  Ampicillin: 250,
  Clindamycin: 150,
  Cefazolin: 100,
  Onsior: 20,
  Buprenorphine: 0.5,
  Cerenia: 10,
  Diphenhydramine: 50
};
